export default __webpack_public_path__ + "static/media/seedfund-help.dead4914.svg";